import { format } from "date-fns";
import React from "react";
import { MdRecentActors } from "react-icons/md";

const RecentLog = ({ data = [] }) => {
  return (
    <div className="card">
      <div className="card-body">
        <div className="d-flex justify-content-between gap-1">
          <div className="d-flex gap-1">
            <MdRecentActors size="20" />
            <h5>Recent Log</h5>
          </div>
          <div className="align-self-start">
            <span
              className="fw-medium text-dark"
              style={{ fontSize: "0.7rem" }}
            >
              Total
            </span>
            <span
              className="text-darker fw-medium"
              style={{ fontSize: "0.6rem" }}
            >{`(${data.length || 0})`}</span>
          </div>
        </div>
        <div
          className="scroll-container mt-2"
          style={{ maxHeight: "270px", overflowY: "auto" }}
        >
          {data.map((log) => {
            const logTypeColor = {
              ASSIGNED: "text-bg-primary-soft",
              RETURNED: "text-bg-secondary-soft",
              MOVED: "text-bg-info-soft",
              MAINTENANCE: "text-bg-warning-soft",
              DISPOSED: "text-bg-danger-soft",
              TRANSFERRED:"text-bg-warning-soft",
            };

            const toWhom =
              log.to_employee_name ||
              log.to_department_name ||
              log.to_area_name ||
              "N/A";

            return (
              <div key={log.id} className="py-1">
                <div className="d-flex justify-content-between align-items-center">
                  <div
                    className="text-darker fw-medium"
                    style={{ fontSize: "0.8rem" }}
                  >
                    <span>{log?.asset_name || "-"}</span>{" "}
                    <span>#{log?.asset_number || "-"}</span>
                  </div>
                  <span
                    className={`badge ${
                      logTypeColor[log.log_type] || "dark"
                    } text-uppercase`}
                    style={{ fontSize: "0.6rem" }}
                  >
                    {log?.log_type || "-"}
                  </span>
                </div>

                <div className="d-flex justify-content-between align-items-center text-dark fw-medium">
                  <span style={{ fontSize: "0.75rem" }}>
                    By {log?.performed_by_name || "Unknown"}
                  </span>
                  <span style={{ fontSize: "0.75rem" }}>
                    {log.created_at
                      ? format(log.created_at, "dd MMM hh:mm a")
                      : "-"}
                  </span>
                </div>

                {log.log_type === "ASSIGNED" && (
                  <div
                    className="text-dark fw-medium"
                    style={{ fontSize: "0.75rem" }}
                  >
                    ➜ To: <span>{toWhom}</span>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default RecentLog;
